import * as React from 'react';
import SuperCritical from 'lib/supercritical';

export const LoadingIcon = SuperCritical(({ loading } : { loading: () => boolean }) => 
    <i className={"loadingicon fa fa-spinner fa-spin" + (loading() ? " loading" : '')}></i>);


// WEBPACK FOOTER //
// ./apps/portcall/homepage/loadingicon.tsx